import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Wrapper,
  Container,
  ContainerMobile,
  TitleWrapper,
  Title,
  EquipName,
  SideWrapper,
  PointsWrapper,
  Points,
  Icon,
  LogoContainer,
  PointsContainer,
  LogoContainerDesktop
} from './styles'
import { HiChevronLeft } from 'react-icons/hi'
import Timer from '../timer'
import Logo from '../logo'
import { useGame, usePage } from '../../contexts'
import { getTeam } from '../../utils/team_helpers'
import { getAssetUrl } from '../../utils/assets_helpers'
import Settings from '../settings'
import { isMobile } from '../../utils/general'
// import { GameType } from '../../../data/data-store/models'
import { t } from '../../adapters/translate/translate'

export type IHeaderProps = {
  title: string;
  type: 'title' | 'timer' | 'blank';
  teamName: string;
  timeInSeconds: number;
  points: number;
  paused: boolean;
  timeout: boolean;
}

export const initialHeaderConfig: IHeaderProps = {
  title: '',
  type: 'blank',
  teamName: '',
  timeInSeconds: 60,
  points: 0,
  paused: false,
  timeout: true
}

const Header = () => {
  const [title, setTitle] = useState('')
  const [timeInSeconds, setTimeInSeconds] = useState(0)
  const [teamName, setTeamName] = useState<string|null>('')
  const [currentType, setCurrentType] = useState<'title'|'timer'|'blank'>('title')
  const team = getTeam()
  const navigate = useNavigate()
  const location = useLocation()
  const { game, points, isTogether } = useGame()
  const { soundActivated, headerConfig, hasBackButton, logo } = usePage()

  function handleGoToHome () {
    if (isTogether() && location.pathname === '/mission') {
      navigate('/')
    }
  }

  function loadMenuItems () {
    setTitle(headerConfig.title)
    setCurrentType(headerConfig.type)
    setTimeInSeconds(headerConfig.timeInSeconds)
    setTeamName(team?.name || null)
  }

  useEffect(() => {
    loadMenuItems()
  }, [soundActivated, headerConfig, hasBackButton])

  return (
    <Wrapper data-id="wrapper" $isMobile={isMobile()}>
      <Container data-id="container" $isMobile={isMobile()}>
        <SideWrapper>
          <LogoContainerDesktop onClick={handleGoToHome} color={game?.textColor}>
            {isTogether() && location.pathname === '/mission'
              ? <><HiChevronLeft /><span>{t('Return')}</span></>
              : <Logo centerImage={false} />
            }
          </LogoContainerDesktop>
        </SideWrapper>

        {currentType === 'title' && (
          <TitleWrapper>
            <Title style={{ color: game?.textColor || '#fff' }}>{title}</Title>
            {teamName && <EquipName style={{ color: game?.textColor || '#fff' }}>{isTogether() && ('Time: ') }{teamName}</EquipName>}
          </TitleWrapper>
        )}

        { currentType === 'timer' && <Timer paused={headerConfig.paused} className="tour-3" timeInSeconds={timeInSeconds}/> }

        <PointsWrapper>
          {game?.pointsHeaderImage && <Icon className={window.innerWidth > 768 ? 'tour-2' : ''} src={getAssetUrl('pointsHeaderImage', game?.pointsHeaderImage)}/>}
          <Points style={{ color: game?.textColor || '#fff' }} className={window.innerWidth > 768 ? 'tour-2' : ''}>{points}</Points>
        </PointsWrapper>
        {game?.type === 'LINEAR' && (<Settings />)}
      </Container>

      <ContainerMobile data-id="containerMobile">
        <LogoContainer onClick={handleGoToHome} color={game?.textColor}>
          {isTogether() && location.pathname === '/mission'
            ? <HiChevronLeft />
            : <img src={logo} alt="" />
          }
        </LogoContainer>

        {currentType === 'title' && (<TitleWrapper>
            {<EquipName color='#1E1E1E'>{game.name}</EquipName>}
          </TitleWrapper>)}
        {currentType === 'timer' && <Timer paused={headerConfig.paused} className="tour-3" timeInSeconds={timeInSeconds} />}

        <PointsContainer>
          {game?.pointsHeaderImage && <Icon src={getAssetUrl('pointsHeaderImage', game?.pointsHeaderImage)}/>}
          <Points className={window.innerWidth < 768 ? 'tour-2' : 'asad'} color="#1E1E1E">{points} pts</Points>
        </PointsContainer>
      </ContainerMobile>
    </Wrapper>
  )
}

export default Header
